var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.json ? _c("span", [_vm._v("[object]")]) : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }